import React from 'react'

import useNotification from '../../../lib/hooks/useNotification'
import { NotificationType } from '../../../types'
import { SimpleSnackbar } from '../../shared/alerts'

const NotificationManager = () => {
  const { notifPayload } = useNotification()

  if (!notifPayload) {
    return null
  }

  const { message, onClose, onRetry, refresh, retryAria, type, viewUrl, viewAria } =
    notifPayload || {
      message: '',
      type: NotificationType.Success
    }

  return (
    <SimpleSnackbar
      message={message}
      onClose={onClose}
      onRetry={onRetry}
      refresh={refresh}
      retryAria={retryAria}
      type={type}
      viewUrl={viewUrl}
      viewAria={viewAria}
    />
  )
}

export default NotificationManager
